exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ly-page[_v-bbf31380]{color:#181a21;margin-top:20px}select[_v-bbf31380]{border:none;color:#747474;background-color:transparent}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-bbf31380&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Page.vue
 ** module id = 56
 ** module chunks = 0
 **/